import { z } from 'zod';
/**
 * Códigos de error del contrato HTTP (docs/09_API.md). El cliente decide por
 * código, nunca por el texto del mensaje.
 */
export const ERROR_CODES = [
    'VALIDATION_ERROR',
    'AUTH_ERROR',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UPLOAD_TOO_LARGE',
    'REVIEW_REQUIRED',
    'CAPABILITY_UNAVAILABLE',
    'FEATURE_NOT_AVAILABLE',
    'BUDGET_NOT_APPROVED',
    'BUDGET_EXCEEDED',
    'CONTINUITY_REVIEW_REQUIRED',
    'RATE_LIMIT',
    'INTERNAL_ERROR',
    'DEPENDENCY_UNAVAILABLE',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const errorEnvelopeSchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        message: z.string().min(1),
        details: z.unknown().optional(),
        requestId: z.string().min(1),
    }),
});
/** Código HTTP asociado a cada código de error. Una sola fuente de verdad. */
export const ERROR_STATUS = {
    VALIDATION_ERROR: 400,
    AUTH_ERROR: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UPLOAD_TOO_LARGE: 413,
    REVIEW_REQUIRED: 422,
    CAPABILITY_UNAVAILABLE: 422,
    FEATURE_NOT_AVAILABLE: 422,
    BUDGET_NOT_APPROVED: 422,
    BUDGET_EXCEEDED: 422,
    CONTINUITY_REVIEW_REQUIRED: 422,
    RATE_LIMIT: 429,
    INTERNAL_ERROR: 500,
    DEPENDENCY_UNAVAILABLE: 503,
};
//# sourceMappingURL=errors.js.map